var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadding-component"},[_c('div',{staticClass:"loadding-component-box"},[_c('van-loading',{attrs:{"color":"#999","text-color":"#999","vertical":true}},[_vm._v("加载中...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }